import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'react-bootstrap'
import { Layout, selectLayout, setLayout } from '../videocallSlice'
import { _ } from '../../../utils/localization'

const OPTIONS: { value: Layout, text: string }[] = [
    { value: 'equal', get text() { return _('videocall.layout.equal') } },
    // Disabled for now, because we need to refine it...
    // { value: 'speaker', get text() { return _('videocall.layout.speaker') } },
    { value: 'host', get text() { return _('videocall.layout.host') } },
]

const LayoutSelect = () => {
    const dispatch = useDispatch()
    const layout = useSelector(selectLayout)
    const onChange = (e) => {
        dispatch(setLayout(e.target.value as Layout))
    }
    return (
        <Form>
            <Form.Group controlId="selectLayout">
                <Form.Control
                    as="select"
                    custom
                    onChange={onChange}
                    value={layout}
                >
                    {OPTIONS.map(({ value, text }) => <option value={value} key={value}>{text}</option>)}
                </Form.Control>
            </Form.Group>
        </Form>
    )
}

export default LayoutSelect
